import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Header from "../components/Header";
import SearchInput from "../../../ui/SearchInput";
import Count from "../components/Count";
import Modal from "../../../ui/Modal";
import {
  useRouteMatch,
  NavLink,
  useParams,
  useLocation,
} from "react-router-dom";
import { GetHook, postEndpoint } from "../../../api/api";
import {
  SCORECARD_URL,
  OBJECTIVE_URL,
  PERSPECTIVE_URL,
} from "../../../api/urls";
import { get } from "../../../utils/get";
import Axios from "../../../utils/axios";
import AddObjective from "./AddObjective";
import { EditDeleteFormatter } from "../../../ui/TableFormatter";
import { StatusIcon } from "../../../assets/svg/StatusIcon";
import CommentIcon from "../../../assets/svg/CommentIcon";
import Comment from "../../../ui/Comment";
import { BASE_API_URL } from "../../../utils/app-constants";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { is360Subject } from "../../../subjects/Is360Subject";
interface IProps {
  scorecard_id?: any;
  scorecard?: any;
}

const ObjectivesComponent = ({ scorecard_id, scorecard }: IProps) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [objectives, setObjectives] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>([]);
  const [objectiveId, setobjectiveId] = useState();
  const [modalContent, setModalContent] = useState("objective");

  const { url } = useRouteMatch();
  const { id }: any = useParams();

  const location = useLocation();
  const { data: perspectives } = GetHook(
    `${SCORECARD_URL}/${scorecard_id}/perspective/v1`
  );

  const { data: rawPerspectives } = GetHook(`${PERSPECTIVE_URL}`);

  const perspective = perspectives.filter(
    (perspective) => perspective.perspective_id === id
  );

  const rawPerspective = rawPerspectives.filter(
    (rawP) => rawP.id === get(perspective, "[0].perspective_id")
  );

  const { data: comments } = GetHook(
    `${BASE_API_URL}/scorecardobjective/${id}/comment`
  );

  const { data, error, pending, reload } = GetHook(
    get(perspective[0], "perspective_id")
      ? `${SCORECARD_URL}/${scorecard_id}/objective/v1?perspective_id=${get(
          perspective[0],
          "perspective_id"
        )}`
      : "null"
  );

  useEffect(() => {
    is360Subject.next(!!get(rawPerspective, "[0].is_360"));
    return () => {};
  }, [rawPerspective]);

  useEffect(() => {
    setObjectives(data);
    return () => {};
  }, [data, id]);

  const toggleModal = (content, objective) => {
    setModalContent(content);
    setobjectiveId(objective.objective_id);
    setisModalOpen(true);
  };

  const setEdit = (objective) => {
    setIsEdit(true);
    setEditData(objective);
    setisModalOpen(true);
  };
  const closeModal = () => {
    setisModalOpen(false);
    setIsEdit(false);
    setEditData({});
    setModalContent("objective");
    reload(get(location, "key"));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          Axios.delete(`${SCORECARD_URL}/${scorecard_id}/objective/${id}`)
            .then((res) => {
              setObjectives(
                objectives.filter((objective: any) => objective?.objective_id != id)
              );
              toast.success("Objective has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };
  const objectivesWeght  = data.map(function(i) {
  return i?.weight;
});
let Objsum = 0;

for (let i = 0; i < objectivesWeght?.length; i++) {
    Objsum += objectivesWeght[i];
}

  return (
    <ObjectiveContainer>
      <ObjectiveHeaderSection>
        <TitleText>
          {perspective && perspective[0]?.perspective?.name}
        </TitleText>
        <DescriptionSection>
          {perspective && get(perspective[0], "notes")}
        </DescriptionSection>
        <TitleText style={{ width: "80%" }}>
        Total Objectives Weight = {Objsum}
        </TitleText>
      </ObjectiveHeaderSection>
      <Header
        title="Objectives"
        count={objectives && objectives.length}
        setisModalOpen={setisModalOpen}
        isEdit={isEdit}
        handleDelete={handleDelete}
      />
      {isModalOpen && (
        <Modal
          title={isEdit ? "Edit Objetive" : "Add new Objective"}
          closeModal={closeModal}
          handleSubmit={handleSubmit}
          noHeader={modalContent === "objective" ? false : true}
          noFooter={modalContent === "comment" ? true : false}
          width={modalContent === "comment" ? "30em" : "40em"}
        >
          {modalContent === "objective" ? (
            <AddObjective
              setHandleSubmit={setHandleSubmit}
              setObjectives={setObjectives}
              objective={objectives}
              closeModal={closeModal}
              scorecard_id={scorecard_id}
              perspective_id={get(perspective[0], "perspective_id")}
              editData={editData}
            />
          ) : (
            <Comment
              closeModal={closeModal}
              url={`scorecardobjective/${objectiveId}`}
              scorecard_id={scorecard_id}
            />
          )}
        </Modal>
      )}
      <SearchInput />
      <Objectives>
        {objectives &&
          objectives.map((objective: any) => (
             <ObjectivesItem
              key={objective.objective_id}
              to={`${url}/objective/${objective.objective_id}`}
              // onDoubleClick={() => setEdit(objective)}
            >
              <TitleText style={{ fontSize: "12px" }}>
                {objective?.objective.name}
              </TitleText>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TitleText
                  style={{
                    marginRight: "1em",
                    color: "#D51067",
                    fontWeight: "normal",
                  }}
                >
                  {objective?.weight}
                </TitleText>
                {get(objective, "comments")?.length > 0 ? (
                  <CommentIconContainer
                    onClick={() => toggleModal("comment", objective)}
                  >
                    {objective.comments.filter(
                      (comment) => comment.status === "new"
                    ).length > 0 ? (
                      <StatusContainer>
                        <StatusIcon />
                      </StatusContainer>
                    ) : null}
                    <CommentIcon />
                  </CommentIconContainer>
                ) : null}

                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                >
                  <EditDeleteFormatter
                    showEdit={() => setEdit(objective)}
                    isActive={
                      (get(scorecard, "[0]status") === "active" || get(scorecard, "[0]status") === "pending-approval") ? true : false
                    }
                    handleDelete={() => handleDelete(objective?.objective_id)}
                    hasComments
                    toggleComment={() => toggleModal("comment", objective)}
                  />
                </span>
              </div>
            </ObjectivesItem>
          ))}
      </Objectives>
    </ObjectiveContainer>
  );
};

export default ObjectivesComponent;

const ObjectiveContainer = styled.div`
  display: grid;
  grid-template-rows: 18em 5em 4.2em auto;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
`;

const ObjectiveHeaderSection = styled.div`
  display: grid;
  grid-template-rows: 3em 7em;
  padding: 1em;
  padding-top: 2.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;

const DescriptionSection = styled.div`
  font-size: 0.75em;
  font-weight: 500;
  font-style: regular;
  color: #cdd3de;
`;

const Objectives = styled.ul`
  display: grid;
  grid-template-rows: repeat(auto-fill, 4.3125em);
  padding: 0;
  margin: 0;
  list-style: none;
`;

const ObjectivesItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5em 1.4em;
  text-decoration: none;
  &.active {
    background-color: #ebefff;
  }
`;

const ListContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  &:active {
    background-color: #ebefff;
  }
`;
const CommentIconContainer = styled.span`
  position: relative;
  height: 1em;
  width: 1em;
  /* margin: 0.3em; */
  display: flex;
  align-items: center;
  padding: 0.5em;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #ccc;
  cursor: pointer;
`;

const StatusContainer = styled.div`
  position: absolute;
  bottom: 1.4em;
  left: 1.5em;
`;
